// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"f510ebff","279":"83f57d27","377":"1a44b821","412":"1c1ced08","426":"7ad26dff","460":"a55ac6b0","641":"1f2274a8","724":"33c2b914","976":"0d9e4cdd","994":"b46b3833"}[chunkId] + ".chunk.css";
};